import React from 'react';
import PostDetailPreviewPopOver from './PostDetailPreviewPopOver';
import Pill from '../components/Pill';
import type { PillSize } from '../components/Pill';
import Tooltip from '../components/Tooltip';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import postPath from '../utils/url/postPath';

const POST_PILL_POST_FRAGMENT = gql(`
  fragment PostPill_post on Post {
    id
    title
    ...postPath_post
  }
`);

interface PostPillProps
  extends Pick<React.ComponentProps<typeof Pill>, 'icon'> {
  onRemove?: React.MouseEventHandler;
  tooltip?: string;
  post: DocumentType<typeof POST_PILL_POST_FRAGMENT>;
  size?: PillSize;
}

const PostPill = ({ onRemove, post, icon, tooltip, size }: PostPillProps) => {
  const content = (
    <Pill
      type="post"
      icon={icon}
      onClick={onRemove}
      to={onRemove ? undefined : postPath(post)}
      size={size}
    >
      {post.title}
    </Pill>
  );

  if (tooltip) {
    return <Tooltip content={tooltip}>{content}</Tooltip>;
  }
  return (
    <PostDetailPreviewPopOver
      allowCrossAxisFlip
      display="inline-block"
      postId={post.id}
    >
      {content}
    </PostDetailPreviewPopOver>
  );
};

export default PostPill;
